import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2hx23125l5: FaireBrandEntity = {
  token: "b_2hx23125l5",
  type: "brand",
  name: "Nurished",
  avatarUrl:
    "https://cdn.faire.com/fastly/6c86402f74d239700c819a657226e407288e03c2858519dfdc06e560c88f46a2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ec52514384b5edd48a9c3cfe3f0dc151012a991c259ee73daee7721f49492cc2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6c86402f74d239700c819a657226e407288e03c2858519dfdc06e560c88f46a2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ec52514384b5edd48a9c3cfe3f0dc151012a991c259ee73daee7721f49492cc2.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "We're Nurished. We are a small team of nutrition experts located in Salt Lake City, UT. We make great tasting, all-natural, whole-food based products. We primarily focus on kids, but we have a few products for mom too! \n\nAs parents, we couldn't believe the ingredients we found in Pediasure, gummy vitamins, and other popular kids products, so we set out on a journey to create a new line of extra yummy products that kids love, with ingredients made from real foods. Because healthy shouldn't be hard. \n\nWhether you're looking to boost your child's immune system, help ensure proper growth, need some help with digestion, or simply want a great tasting product for your child with the best ingredients, you're in the right place. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:05.848Z",
    importedBy: "entity-db-cli",
  },
};
